import { URL_GET_OFFICES } from "@/requests/offices";
import MockAdapter from "axios-mock-adapter/types";
import GetOfficeItem from "@/models/api/offices/GetOfficeResponse";

export const indexOfficesMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_OFFICES).reply(200, [
    {
      id: "832b2314-dbb7-4219-b6e4-ad45c1d75dfe",
      officeShortName: "Company 1",
    } as GetOfficeItem,
    {
      id: "cd895887-5796-4ae3-903b-c9489f274542",
      officeShortName: "Company 2",
    } as GetOfficeItem,
  ]);
};
